import { render } from "./EsgReviewModal.vue?vue&type=template&id=c0d6601e"
import script from "./EsgReviewModal.vue?vue&type=script&lang=js"
export * from "./EsgReviewModal.vue?vue&type=script&lang=js"

import "./EsgReviewModal.vue?vue&type=style&index=0&id=c0d6601e&lang=scss"

import exportComponent from "/Users/pavel/FrontReportTechnomoscow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__